import axios from "axios"

export default {
  loadAppConfig(appCode, cid) {
    const url = `/apps/code/${appCode}/config/client/${cid}`

    return axios.get(url).then(response => {
      return response.data
    })
  },
}
